import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, LogIn } from "lucide-react";
import { toast } from "sonner";
import SEO from "@/components/common/SEO";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiError } from "@/lib/api";

export default function Login() {
    const { user, login } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (user) navigate("/admin", { replace: true });
    }, [user, navigate]);

    async function submit(e) {
        e.preventDefault();
        setLoading(true);
        try {
            await login(email, password);
            toast.success("Sesión iniciada. Bienvenido al departamento interno.");
            navigate("/admin", { replace: true });
        } catch (e) {
            toast.error(
                formatApiError(e.response?.data?.detail) ||
                    "Credenciales inválidas.",
            );
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <SEO
                title="Acceso interno"
                description="Acceso restringido al departamento interno."
                path="/login"
            />
            <section className="min-h-[80vh] flex items-center py-20">
                <div className="container-x max-w-md mx-auto w-full">
                    <div className="dossier" data-testid="login-card">
                        <div className="dossier-header">
                            <span><Lock className="inline w-3 h-3 mr-2" />Acceso restringido</span>
                            <span className="text-[var(--danger)]">Confidencial</span>
                        </div>
                        <div className="dossier-content">
                            <p className="eyebrow mb-4">Departamento interno</p>
                            <h1 className="font-display text-4xl md:text-5xl mb-2 text-[var(--paper-2)]">
                                Iniciar sesión
                            </h1>
                            <p className="font-mono text-xs text-[var(--ink-muted)] mb-8">
                                Solo personal autorizado.
                            </p>
                            <form
                                onSubmit={submit}
                                className="space-y-6"
                                data-testid="login-form"
                            >
                                <div>
                                    <label className="font-mono text-[10px] uppercase tracking-[0.25em] text-[var(--ink-dim)] block mb-2">
                                        Email
                                    </label>
                                    <input
                                        type="email"
                                        required
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        className="input-dossier"
                                        data-testid="login-email"
                                        autoComplete="username"
                                    />
                                </div>
                                <div>
                                    <label className="font-mono text-[10px] uppercase tracking-[0.25em] text-[var(--ink-dim)] block mb-2">
                                        Contraseña
                                    </label>
                                    <input
                                        type="password"
                                        required
                                        value={password}
                                        onChange={(e) =>
                                            setPassword(e.target.value)
                                        }
                                        className="input-dossier"
                                        data-testid="login-password"
                                        autoComplete="current-password"
                                    />
                                </div>
                                <button
                                    type="submit"
                                    disabled={loading}
                                    className="btn-brutal btn-brutal-danger w-full justify-center disabled:opacity-60"
                                    data-testid="login-submit"
                                >
                                    <LogIn className="w-4 h-4" />
                                    {loading ? "Verificando…" : "Entrar"}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
